import React, { ReactElement } from "react";
import Styles from "../styles/Styles";
import MenuIcon from "@material-ui/icons/Menu";
import { DefaultLogo, FontStyles } from "../../../components";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import { masks } from "../../../utils";
type CustomHeaderProps = {
  openMenu: () => void;
  dataAp: any;
};

function Header({ openMenu, dataAp }: CustomHeaderProps) {

  return (
    <Styles.Container>
      <Styles.FirstContentGroup id="header-menu">
        <Styles.Rectangle>
          {/* <Styles.IconMenu /> */}
          <DefaultLogo white maxWidth={"129px"} />
          <Styles.LocContainer>
            <Styles.LocText>
              <HomeWorkIcon style={{ marginRight: "4px" }} />
              {dataAp?.place?.name}
            </Styles.LocText>
            <Styles.PeriodText>
              {dataAp &&
                "Estadia de " +
                  masks.formatDate(dataAp?.startDate) +
                  " a " +
                  masks.formatDate(dataAp?.endDate)}
            </Styles.PeriodText>
          </Styles.LocContainer>
        </Styles.Rectangle>
        {/* {userInfos && (
          <NavigationInfos pathname={pathname} userInfos={userInfos} />
        )} */}
      </Styles.FirstContentGroup>
    </Styles.Container>
  );
}

export default Header;
